// src/components/Login/Login.js
import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Layout, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { login } from '../../services/api';
import { getVersion } from '../../versionConfig';

import toast from 'react-hot-toast';
import logo from '../../images/funique_Earthverse_logo_20240620.png';
import './Login.scss';

const { Content } = Layout;
const { Text } = Typography;

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await login(values.email, values.password);
      toast.success('Login successful!');
      onLogin(values.email);
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  if (!visible) {
    return null; // Return null while the component is not visible
  }

  return (
    <Layout className="login-layout">
      <Content className="login-content">
        <div className="login-card">
          <div className="img-side">
            <img src={logo} alt="Sokuji Logo" className="login-logo" />
            <Text className="version">Version {getVersion()}</Text>
          </div>
          <div className="form-side">
            <Form
              name="login"
              className="login-form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item>
                <h2>登入</h2>
              </Form.Item>
              <Form.Item
                name="email"
                rules={[{ required: true, message: 'Please input your Email!' }]}
              >
                <Input prefix={<UserOutlined />} placeholder="帳號 (E-mail)" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Please input your Password!' }]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="密碼" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" className="login-form-button" loading={loading}>
                  登入
                </Button>
              </Form.Item>
              <Form.Item>
                <a className="login-form-forgot" href="#">
                  🚧忘記密碼 / 解鎖
                </a>
              </Form.Item>
            </Form>
          </div>
        </div>
        <div className="login-footer">
          <Text>© 2024 Funique VR . All Rights Reserved.</Text>
        </div>
      </Content>
    </Layout>
  );
};

export default Login;